<div style="width: 100%" class="d-flex flex-column align-items-center justify-content-between">
    <app-admin-header style="width: 100%" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
      [queryParams]="queryParams" [stats]="stats"></app-admin-header>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    <div class="w-100">
      <!-- skelition   -->
      <app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
    </div>
    <div id="result-parent" class="container-fluid mb-5 mob-px-5 pt-5 222" *ngIf="!skelition">
        <div class="container">
        <div class="row">
          <div class="col-3 my-2">
            <div class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4">
              <span class="{{ 'icon-svg icon-svg-3' }} " style="width: 4rem; height: 4rem"></span>
              <hr class="hr w-75 border-4" />
              <h5 class="text-center p-2">{{ 'Total Count' | translator }}</h5>
              <h1>{{ announcement.totalCount }}</h1>
            </div>
          </div>
          <div class="col-3 my-2">
            <div class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4">
              <span class="{{ 'icon-svg icon-svg-15' }} " style="width: 4rem; height: 4rem"></span>
              <hr class="hr w-75 border-4" />
              <h5 class="text-center p-2">{{ 'Seen Count' | translator }}</h5>
              <h1>{{ announcement.seenCount }}</h1>
            </div>
          </div>
          <div class="col-3 my-2">
            <div class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4">
              <span class="{{ 'icon-svg icon-svg-59' }} " style="width: 4rem; height: 4rem"></span>
              <hr class="hr w-75 border-4" />
              <h5 class="text-center p-2">{{ 'Start Date' | translator }}</h5>
              <h6>{{ announcement.startDate }}</h6>
            </div>
          </div>
          <div class="col-3 my-2">
            <div class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4">
              <span class="{{ 'icon-svg icon-svg-59' }} " style="width: 4rem; height: 4rem"></span>
              <hr class="hr w-75 border-4" />
              <h5 class="text-center p-2">{{ 'End Date' | translator }}</h5>
              <h6>{{ announcement.endDate }}</h6>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <h2 class="v4-color-white">{{ ('Users List' | translator) }}</h2>
          <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-0 p-0">
            <p-table [value]="announcement.targetUsers" dataKey="_id" [paginator]="false" [tableStyle]="{'min-width': '50rem','margin':'2rem 0rem'}">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="min-width:200px">{{"user name" | translator}}</th>
                        <th style="min-width:200px">{{"Email" | translator}}</th>
                        <th style="min-width:200px">{{"Phone" | translator}}</th>
                        <th style="min-width:200px">{{"Gender" | translator}}</th>
                        <th style="min-width:200px">{{"SeenAt" | translator}}</th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-Users>
                    <tr>
                        <td>{{Users.name.first +' ' + Users.name.middle + ' ' + Users.name.last}}</td>
                        <td>{{Users.email}}</td>
                        <td>{{Users.phone}}</td>
                        <td>{{Users.gender}}</td>
                        <td>{{ (Users?.seenAt) ? (Users?.seenAt | date:'dd-MM-yyyy HH:mm:ss') : '-' }}</td>
                    </tr>
                </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>

    <p-button *ngIf="announcement.assessmentId" label='{{"Assessment Results"| translator}}' icon="pi pi-eye" (onClick)="openAssessmentPage(announcement)"
    styleClass="create-training-btn"></p-button>
    
  </div>




  <app-footer></app-footer>
  <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>